import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BulkImportDetail } from "@/features/bulk-imports/components/BulkImportDetail";

export function BulkImportDetailPage() {
  const navigate = useNavigate();
  const { batchId } = useParams<{ batchId: string }>();
  const handleBatchUpdated = () => undefined;

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Detalle de importacion</h1>
          <p className="text-sm text-muted-foreground">
            Revision, validacion y commit del lote seleccionado.
          </p>
        </div>
        <Button
          variant="outline"
          onClick={() => navigate("/contabilidad/importaciones")}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Volver a importaciones
        </Button>
      </div>

      <BulkImportDetail
        batchId={batchId ?? null}
        onBatchUpdated={handleBatchUpdated}
      />
    </div>
  );
}
